import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

interface Props {
  /** Why a check is due, in the server's words ("Plan changed"). */
  reason: string;
  isRunning: boolean;
  disabled?: boolean;
  onRunCheck: () => void;
}

/** Offers a check for a plan whose member ID or payer changed (GDN-4267). */
export const PlanChangedCheckOffer: React.FC<Props> = ({
  reason,
  isRunning,
  disabled = false,
  onRunCheck,
}) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
    <Typography variant="body2" color="text.secondary">
      {reason}
    </Typography>
    <Button size="small" variant="outlined" disabled={disabled || isRunning} onClick={onRunCheck}>
      {isRunning ? 'Running…' : 'Run check'}
    </Button>
  </Stack>
);
